import React from 'react';
import T from 'prop-types';
// components
import AudioPlayer from '../AudioPlayer/AudioPlayer';
// styles
import styles from './Lecture.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

const Lecture = ({ className, modalData: { content, title, sound_link } }) => (
  <div className={cx('container', className)}>
    <h3 className={cx('title')}>{title}</h3>
    <AudioPlayer title={title} src={sound_link} />
    <p className={cx('text')} dangerouslySetInnerHTML={{ __html: content }} />
  </div>
);

Lecture.propTypes = {
  className: T.string,
  modalData: T.shape({
    content: T.string,
    title: T.string
  }).isRequired
};

export default Lecture;



// WEBPACK FOOTER //
// ./src/components/Lecture/Lecture.jsx